export default "__VITE_ASSET__CVkvQ_Zo__"